import React from "react";
import { Pagination } from "react-bootstrap";

interface PagerProps {
  page: number;
  totalPages: number;
  onChange: (newPage: number) => void;
}

interface PagerState {
  page: number;
}

class Pager extends React.Component<PagerProps, PagerState> {
  constructor(props: PagerProps) {
    super(props);
    this.state = {
      page: props.page
    };
  }

  componentDidUpdate(prevProps: PagerProps) {
    if (prevProps.page !== this.props.page) {
      this.setState({ page: this.props.page });
    }
  }

  goToPage(newPage: number) {
    if (newPage < 1 || newPage > this.props.totalPages) return;
    this.setState({ page: newPage });
    this.props.onChange(newPage);

    const url = new URL(window.location.href);
    url.searchParams.set("page", newPage.toString());
    window.history.pushState("", "", url.toString());
  }

  renderPaginationItems() {
    const { totalPages } = this.props;
    const { page } = this.state;
    const items = [];

    let start = Math.max(1, page - 2);
    let end = Math.min(totalPages, page + 2);

    if (start > 1) {
      items.push(<Pagination.Item key={1} onClick={() => this.goToPage(1)}>1</Pagination.Item>);
      if (start > 2) items.push(<Pagination.Ellipsis key="start-ellipsis" disabled />);
    }

    for (let i = start; i <= end; i++) {
      items.push(
        <Pagination.Item
          key={i}
          active={i === page}
          onClick={() => this.goToPage(i)}
        >
          {i}
        </Pagination.Item>
      );
    }

    if (end < totalPages) {
      if (end < totalPages - 1) items.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
      items.push(<Pagination.Item key={totalPages} onClick={() => this.goToPage(totalPages)}>{totalPages}</Pagination.Item>);
    }

    return items;
  }

  render() {
    const { page } = this.state;
    const { totalPages } = this.props;

    return (
      <Pagination className="justify-content-center mt-3">
        <Pagination.First onClick={() => this.goToPage(1)} disabled={page === 1} />
        <Pagination.Prev onClick={() => this.goToPage(page - 1)} disabled={page === 1} />
        {this.renderPaginationItems()}
        <Pagination.Next onClick={() => this.goToPage(page + 1)} disabled={page === totalPages} />
        <Pagination.Last onClick={() => this.goToPage(totalPages)} disabled={page === totalPages} />
      </Pagination>
    );
  }
}

export default Pager;
